<ion-content>
  @if (checkWinnings; as winningDetails) {
    <div class="background-image">
      <ng-lottie class="lottie-animation" [options]="{ path: './../../../assets/twinklestars1_white.json' }">
      </ng-lottie>
      <ion-grid class="ion-no-padding">
        <ion-row class="ion-no-padding">
          <div class="gift-papers">
            <h1 class="heading-text-white">{{ "check-winnings.summary" | translate }}</h1>
            @if (!isExpandedSubTitle) {
              <p class="sub-heading">{{ "check-winnings.since_checked" | translate }}</p>
            }
            @if (isExpandedSubTitle) {
              <p class="sub-heading">{{ "check-winnings.since_checked" | translate }}</p>
            }
            <p class="sub-heading-white" style="display: none">{{ winningDetails?.title }}</p>
          </div>
        </ion-row>
      </ion-grid>
      @if (checkWinnings) {
        <div class="content-wrapper">
          <!--Cash Winnings card-->
          @if (checkWinnings?.cash_wom) {
            <ion-card style="margin-top: -4vh"
              class="accordion-cash-winnings accordion-card"
              [@openCloseCredit]="isCashWinningsExpanded ? 'open' : 'closed'">
              <ion-grid class="ion-no-padding">
                <ion-row class="cash-winnings-wrapper">
                  <ion-col size="7">
                    <h1 class="winning-type flex-center">
                      <img src="assets/images/CashIcon.svg" class="win-icon width-31 margin-right-2">
                      {{ "check-winnings.Cash winnings" | translate }}
                    </h1>
                  </ion-col>
                  <ion-col size="4">
                    @if (
                      (checkWinnings?.preferred_currency?.cash_won_sum
                      ? checkWinnings?.preferred_currency?.cash_won_sum
                      : checkWinnings?.cash_won_sum) > 0
                      ) {
                      <h1 class="winning-amount">
                        {{ currencySymbol
                        }}{{
                        (checkWinnings?.preferred_currency?.cash_won_sum
                        ? checkWinnings?.preferred_currency?.cash_won_sum
                        : checkWinnings?.cash_won_sum
                        ) | displayCurrency
                        }}
                      </h1>
                    }
                  </ion-col>
                  <ion-col size="1" class="ion-no-padding">
                    <ion-icon [name]="isCashWinningsExpanded ? 'chevron-up-outline' : 'chevron-down-outline'"
                      class="arrow-icon" (click)="showDescription('cash')">
                    </ion-icon>
                  </ion-col>
                </ion-row>
                @if (isCashWinningsExpanded) {
                  <ion-row>
                    <p class="credit-winnings-hint txt-clr-light-blue text-margin">
                      <!-- Manage your cash winnings in the <span class="link-text-blue">cashout section of your account</span> -->
                      {{ "check-winnings.Manage" | translate }}
                      <span class="link-text-blue" (click)="routeToCashoutPage()">
                      {{ "check-winnings.account" | translate }}</span>
                    </p>
                    <div class="credit-btn">
                      <button class="check-btn" (click)="routeToCashoutPage()">{{'breakdown.cash_out' | translate}}</button>
                    </div>
                  </ion-row>
                }
              </ion-grid>
            </ion-card>
          }
          <!--Credit Winnings card-->
          @if (checkWinnings?.credit_won) {
            <ion-card class="accordion-credit-winnings accordion-card"
              [@openCloseCredit]="isCreditWinningsExpanded ? 'open' : 'closed'">
              <ion-grid class="ion-no-padding">
                <ion-row class="cash-winnings-wrapper">
                  <ion-col size="7">
                    <h1 class="winning-type flex-center">
                      <img src="assets/images/CreditWalletPink.svg" class="win-icon width-31 margin-right-7">
                      {{'check-winnings.Credit winnings' | translate}}
                    </h1>
                  </ion-col>
                  <ion-col size="4">
                    @if (
                      (checkWinnings?.preferred_currency?.credit_won_sum
                      ? checkWinnings?.preferred_currency?.credit_won_sum
                      : checkWinnings?.credit_won_sum) > 0
                      ) {
                      <h1 class="winning-amount">
                        {{ currencySymbol
                        }}{{
                        (checkWinnings?.preferred_currency?.credit_won_sum
                        ? checkWinnings?.preferred_currency?.credit_won_sum
                        : checkWinnings?.credit_won_sum
                        ) | displayCurrency
                        }}
                      </h1>
                    }
                  </ion-col>
                  <ion-col size="1" class="ion-no-padding">
                    <ion-icon [name]="isCreditWinningsExpanded ? 'chevron-up-outline' : 'chevron-down-outline'"
                      class="arrow-icon" (click)="showDescription('credit')">
                    </ion-icon>
                  </ion-col>
                </ion-row>
                @if (isCreditWinningsExpanded) {
                  <p class="credit-winnings-hint txt-clr-light-blue text-margin">
                    {{ "check-winnings.converted" | translate }}
                  </p>
                }
                <ion-row class="expanded-block">
                  <div class="credit-btn">
                    <button class="check-btn" (click)="openConvertToCash()">
                      {{ "check-winnings.Convert" | translate }}
                    </button>
                  </div>
                </ion-row>
              </ion-grid>
            </ion-card>
          }
          <!--lucky dip card-->
          @if (
            (checkWinnings?.preferred_currency?.luckydip_won
            ? checkWinnings?.preferred_currency?.luckydip_won
            : checkWinnings?.luckydip_won) > 0
            ) {
            <ion-card class="accordion-lucky-dip accordion-card" [@openCloseCredit]="isLuckyDipExpanded ? 'open' : 'closed'">
              <ion-grid class="ion-no-padding">
                <ion-row class="cash-winnings-wrapper">
                  <ion-col size="8">
                    <h1 class="winning-type">{{ "check-winnings.Lucky dip" | translate }}</h1>
                  </ion-col>
                  <ion-col size="3">
                    @if (
                      (checkWinnings?.preferred_currency?.luckydip_won
                      ? checkWinnings?.preferred_currency?.luckydip_won
                      : checkWinnings?.luckydip_won) > 0
                      ) {
                      <h1 class="winning-amount">
                        {{ currencySymbol
                        }}{{
                        checkWinnings?.luckydip_value *
                        (checkWinnings?.preferred_currency?.luckydip_won
                        ? checkWinnings?.preferred_currency?.luckydip_won
                        : checkWinnings?.luckydip_won) | displayCurrency
                        }}
                      </h1>
                    }
                  </ion-col>
                  <ion-col size="1" class="ion-no-padding">
                    <ion-icon [name]="isLuckyDipExpanded ? 'chevron-up-outline' : 'chevron-down-outline'" class="arrow-icon"
                      (click)="showDescription('luckyDip')">
                    </ion-icon>
                  </ion-col>
                </ion-row>
                @if (isLuckyDipExpanded) {
                  <ion-row>
                    <p class="credit-winnings-hint txt-clr-light-blue">
                      {{ currencySymbol
                      }}{{
                      checkWinnings?.luckydip_value *
                      (checkWinnings?.preferred_currency?.luckydip_won
                      ? checkWinnings?.preferred_currency?.luckydip_won
                      : checkWinnings?.luckydip_won) | displayCurrency
                      }}
                      {{ "check-winnings.match" | translate }}
                      <span class="link-text-blue" (click)="routeToStorePage()" tabindex="0" role="button" (keydown.enter)="routeToStorePage()" (keydown.space)="routeToStorePage()">{{ 'check-winnings.Use' | translate }}</span>
                    </p>
                  </ion-row>
                }
              </ion-grid>
            </ion-card>
          }
          <!--Reward points card-->
          @if (checkWinnings?.points_won) {
            <ion-card class="accordion-reward-points accordion-card"
              [@openCloseCredit]="isRewardPointsExpanded ? 'open' : 'closed'">
              <ion-grid class="ion-no-padding">
                <ion-row class="cash-winnings-wrapper">
                  <ion-col size="7">
                    <h1 class="winning-type flex-center">
                      <img src="assets/images/pointIcon.png" class="win-icon width-31 margin-right-2">
                      {{ "check-winnings.Reward points" | translate }}
                    </h1>
                  </ion-col>
                  <ion-col size="4">
                    <h1 class="winning-amount">{{ checkWinnings?.points_won_sum | number: "1.0-2" }}</h1>
                  </ion-col>
                  <ion-col size="1" class="ion-no-padding">
                    <ion-icon [name]="isRewardPointsExpanded ? 'chevron-up-outline' : 'chevron-down-outline'"
                      class="arrow-icon" (click)="showDescription('rewards')">
                    </ion-icon>
                  </ion-col>
                </ion-row>
                @if (isRewardPointsExpanded) {
                  <ion-row class="play-game-block">
                    <p class="credit-winnings-hint txt-clr-light-blue text-margin"> {{'check-winnings.points' |
                      translate}}<span>
                      {{'check-winnings.play_games' | translate}}
                      </span><span>{{'check-winnings.win_cash' | translate}} </span><span
                      class="up-to"><b>{{'check-winnings.up_to' | translate}}</b></span>
                    </p>
                    @if (showPlayGame) {
                      <div class="credit-btn">
                        <button class="check-btn" (click)="routeToGamePage()">{{'check-winnings.play_games' |
                        translate}}</button>
                      </div>
                    }
                  </ion-row>
                }
              </ion-grid>
            </ion-card>
          }
          <!-- Lucky Numbers card -->
          @if (remoteConfigLuckyNumber) {
            <ion-card class="accordion-lucky-numbers accordion-card"
              [@openCloseCredit]="isluckyNumbersExpanded ? 'open' : 'closed'">
              <ion-grid class="ion-no-padding">
                <ion-row class="cash-winnings-wrapper">
                  <ion-col size="7">
                    <h1 class="winning-type green-text">{{ title }}</h1>
                  </ion-col>
                  <ion-col size="4">
                    <h1 class="winning-amount"></h1>
                  </ion-col>
                  <ion-col size="1" class="ion-no-padding">
                    <ion-icon [name]="isluckyNumbersExpanded ? 'chevron-up-outline' : 'chevron-down-outline'"
                      class="arrow-icon" (click)="showDescription('luckyNumbers')">
                    </ion-icon>
                  </ion-col>
                </ion-row>
                @if (!isluckyNumbersExpanded) {
                  <div class="cash-winnings-subwrapper">
                    @if (checkWinnings?.lucky_numbers?.prize_draw_entries > 0) {
                      <ion-row class="cash-winnings-wrapper">
                        <ion-col size="7">
                          <h1 class="winning-type">{{ prizeDrawEntries }}</h1>
                        </ion-col>
                        <ion-col size="4">
                          <h1 class="winning-amount">
                            x{{
                            checkWinnings?.lucky_numbers?.prize_draw_entries
                            ? checkWinnings?.lucky_numbers?.prize_draw_entries
                            : 0
                            }}
                          </h1>
                        </ion-col>
                        <ion-col size="1" class="ion-no-padding"> </ion-col>
                      </ion-row>
                    }
                    @if (checkWinnings?.lucky_numbers?.replenished) {
                      <ion-row class="cash-winnings-wrapper">
                        <ion-col size="7">
                          <h1 class="winning-type">{{ replenished }}</h1>
                        </ion-col>
                        <ion-col size="4">
                          <h1 class="winning-amount">
                            x{{ checkWinnings?.lucky_numbers?.replenished ? checkWinnings?.lucky_numbers?.replenished : 0 }}
                          </h1>
                        </ion-col>
                        <ion-col size="1" class="ion-no-padding"></ion-col>
                      </ion-row>
                    }
                  </div>
                }
                @if (isluckyNumbersExpanded) {
                  <ion-row>
                    <ion-col size="12" class="cash-winnings-wrapper ion-no-padding">
                      <ion-row class="cash-header-wrapper">
                        <ion-col size="6">
                          <h1 class="winning-type green-text">{{ prizeDrawEntries }}</h1>
                        </ion-col>
                        <ion-col size="4">
                          <h1 class="winning-amount">
                            x{{
                            checkWinnings?.lucky_numbers?.prize_draw_entries
                            ? checkWinnings?.lucky_numbers?.prize_draw_entries
                            : 0
                            }}
                          </h1>
                        </ion-col>
                      </ion-row>
                      <ion-row class="cash-body-wrapper">
                        <p class="lucky-numbers-hint txt-clr-light-blue" [innerHTML]="prizeDrawContent"></p>
                      </ion-row>
                    </ion-col>
                    <ion-col size="12" class="cash-winnings-wrapper ion-no-padding">
                      <ion-row class="cash-header-wrapper">
                        <ion-col size="7">
                          <h1 class="winning-type green-text">{{ replenished }}</h1>
                        </ion-col>
                        <ion-col size="4">
                          <h1 class="winning-amount">
                            x{{ checkWinnings?.lucky_numbers?.replenished ? checkWinnings?.lucky_numbers?.replenished : 0 }}
                          </h1>
                        </ion-col>
                      </ion-row>
                      <ion-row class="cash-body-wrapper">
                        <p class="lucky-numbers-hint txt-clr-light-blue">{{ replenishedDesc }}</p>
                      </ion-row>
                    </ion-col>
                  </ion-row>
                }
              </ion-grid>
            </ion-card>
          }
          <!-- Gold Rings card -->
          @if (checkWinnings?.gold_ring?.lines_boosted > 0 || checkWinnings?.gold_ring?.replenished > 0) {
            <ion-card class="accordion-lucky-numbers gold-rings-container accordion-card"
              [@openCloseCredit]="isGoldRingsExpanded ? 'open' : 'closed'"
              >
              <ion-grid class="ion-no-padding">
                <ion-row class="cash-winnings-wrapper">
                  <ion-col size="6">
                    <h1 class="winning-type mustard-text">{{ goldRingsTitle }}</h1>
                  </ion-col>
                  <ion-col size="5">
                    <h1 class="winning-amount"></h1>
                  </ion-col>
                  <ion-col size="1" class="ion-no-padding">
                    <ion-icon [name]="isGoldRingsExpanded ? 'chevron-up-outline' : 'chevron-down-outline'" class="arrow-icon"
                      (click)="showDescription('goldRings')">
                    </ion-icon>
                  </ion-col>
                </ion-row>
                @if (!isGoldRingsExpanded) {
                  <div class="cash-winnings-subwrapper">
                    @if (checkWinnings?.gold_ring?.lines_boosted > 0) {
                      <ion-row class="cash-winnings-wrapper">
                        <ion-col size="6">
                          <h1 class="winning-type">{{ goldRingsLinesBoosted }}</h1>
                        </ion-col>
                        <ion-col size="5">
                          <h1 class="winning-amount">x{{
                            checkWinnings?.gold_ring?.lines_boosted ?? 0
                          }}</h1>
                        </ion-col>
                        <ion-col size="1" class="ion-no-padding">
                        </ion-col>
                      </ion-row>
                    }
                    @if (checkWinnings?.gold_ring?.replenished) {
                      <ion-row class="cash-winnings-wrapper">
                        <ion-col size="6">
                          <h1 class="winning-type">{{ goldRingsReplenished }}</h1>
                        </ion-col>
                        <ion-col size="5">
                          <h1 class="winning-amount">x{{ checkWinnings?.gold_ring?.replenished ?? 0 }}</h1>
                        </ion-col>
                        <ion-col size="1" class="ion-no-padding"></ion-col>
                      </ion-row>
                    }
                  </div>
                }
                @if (isGoldRingsExpanded) {
                  <ion-row>
                    <ion-col size="12"  class="cash-winnings-wrapper">
                      <ion-row class="cash-header-wrapper">
                        <ion-col size="7">
                          <h1 class="winning-type mustard-text">{{ goldRingsLinesBoosted }}</h1>
                        </ion-col>
                        <ion-col size="4">
                          <h1 class="winning-amount">x{{
                            checkWinnings?.gold_ring?.lines_boosted
                          }}</h1>
                        </ion-col>
                      </ion-row>
                      <ion-row class="cash-body-wrapper">
                        <p class="lucky-numbers-hint txt-clr-light-blue" [innerHTML]="goldRingsBoosterContent"></p>
                      </ion-row>
                    </ion-col>
                    <ion-col size="12" class="cash-winnings-wrapper">
                      <ion-row class="cash-header-wrapper">
                        <ion-col size="7">
                          <h1 class="winning-type mustard-text">{{ goldRingsReplenished }}</h1>
                        </ion-col>
                        <ion-col size="4">
                          <h1 class="winning-amount">x{{ checkWinnings?.gold_ring?.replenished }}</h1>
                        </ion-col>
                      </ion-row>
                      <ion-row  class="cash-body-wrapper">
                        <p class="lucky-numbers-hint txt-clr-light-blue">{{ goldRingsReplenishedDesc }}</p>
                      </ion-row>
                    </ion-col>
                  </ion-row>
                }
              </ion-grid>
            </ion-card>
          }
          <!-- Win more promise Card -->
          @if (syndicateData?.length > 0) {
            <ion-card class="accordion-card"
              [@openCloseCredit]="isWinMoreExpanded? 'open' : 'closed'">
              <ion-grid class="ion-no-padding">
                <ion-row class="cash-winnings-wrapper">
                  <ion-col size="7">
                    <h1 class="winning-type" style="display: flex;align-items: center;">
                      <img src="assets/icons/Winmore_icon.svg" width="36" height="36">
                      {{'check-winnings.win_more_promise' | translate}}
                    </h1>
                  </ion-col>
                  <ion-col size="4">
                    <h1 class="winning-amount">{{syndicateData?.length}}</h1>
                  </ion-col>
                  <ion-col size="1" class="ion-no-padding">
                    <ion-icon [name]="isWinMoreExpanded ? 'chevron-up-outline' : 'chevron-down-outline'" class="arrow-icon"
                      (click)="showDescription('win')">
                    </ion-icon>
                  </ion-col>
                </ion-row>
                <ion-row class="play-game-block">
                  <p class="credit-winnings-hint txt-clr-light-blue text-margin">
                    {{'check-winnings.you_have' | translate}} <b>{{'check-winnings.win_more_promise' | translate}}</b>
                    {{(syndicateData?.length > 1) ? ('check-winnings.active_on' | translate) + ' ' + syndicateData?.length + ' '
                    + ('check-winnings.syndicates' | translate) : ('check-winnings.active' | translate)}}
                  </p>
                </ion-row>
                @if (isWinMoreExpanded) {
                  <div>
                    @for (winMoreDetails of syndicateData; track winMoreDetails; let i = $index) {
                      <ion-row class="card-wrapper-progress">
                        @if (winMoreDetails?.win_more_end === false) {
                          <ion-col size="12">
                            <div class="card-wrapper">
                              <div class="topbar">
                                <div class="left">{{winMoreDetails?.syndicate_name}}</div>
                                <div class="right">{{winMoreDetails?.left_days}} {{'check-winnings.days_left' | translate}}</div>
                              </div>
                              <div class="card">
                                <div class="row-bar">
                                  <div class="title">{{'check-winnings.together' | translate}}</div>
                                  <div class="progress">
                                    <div class="progress-bar">
                            <div class="fill" [ngStyle]="{
                               'width.%':  winMoreDetails?.togetherProgress <= 100 ? winMoreDetails?.togetherProgress : 0,
                               background: 'linear-gradient(180deg, #17D9D2 0%, #1FD583 100%)'
                             }"></div>
                                    </div>
                                  </div>
                                  <div class="number">{{winMoreDetails?.win_more_promise_details?.together_win_count ?
                                  winMoreDetails?.win_more_promise_details?.together_win_count : 0 }}</div>
                                </div>
                                <div class="row-bar">
                                  <div class="title">{{'check-winnings.alone' | translate}}</div>
                                  <div class="progress">
                                    <div class="progress-bar">
                            <div class="fill" [ngStyle]="{
                               'width.%': winMoreDetails?.aloneProgress <= 100 ? winMoreDetails?.aloneProgress : 0,
                               background: 'linear-gradient(180deg, #17D9D2 0%, #1FD583 100%)'
                             }"></div>
                                    </div>
                                  </div>
                                  <div class="number">{{winMoreDetails?.win_more_promise_details?.alone_win_count ?
                                  winMoreDetails?.win_more_promise_details?.alone_win_count: 0}}</div>
                                </div>
                              </div>
                            </div>
                          </ion-col>
                        }
                      </ion-row>
                    }
                  </div>
                }
              </ion-grid>
            </ion-card>
          }
          <!-- Win mor Promise start-->
          <!--Surprise gift card-->
          <!--Surprise gift card-->
          @if (checkWinnings?.gift_won_details?.title) {
            <ion-card class="surprisegift-card accordion-card d-flex" (click)="openSlideUp(checkWinnings?.gift_won_animation)"
              >
              <ng-lottie class="gift-carrd-animation" [options]="{ path: animationPath , loop: true}">
              </ng-lottie>
              <div class="winning-gift-detail">
                <p class="gift-para">{{"check-winnings.your_surprise" | translate}}</p>
                <h2 class="gift-des">{{ shortDiscription() ??
                checkWinnings?.gift_won_details?._short_description[languageCode] }}</h2>
              </div>
            </ion-card>
          }
          <div class="button-section">
            <ion-button expand="block" color="secondary" class="capsule-btn common-margin" type="submit"
              (click)="openBreakdown(checkWinnings?.encr_claim_event_id)">{{ "check-winnings.View breakdown" | translate
              }}
            </ion-button>
            <h1 (click)="routeToSyndicate()">{{ "check-winnings.syndicate" | translate }}</h1>
          </div>
        </div>
      }
    </div>
    <div class="page-background-blue"></div>
    @if (isAnimationVisible()) {
      <ng-lottie  class="lottie-animation credit-point-lottie"  [class.set-z-index]='isSetIndexSignal()' [options]="lottieOptions" (animationCreated)="animationCreated($event)"></ng-lottie>
    }
  } @else {
    <app-in-progress-animation></app-in-progress-animation>
  }
</ion-content>
